import { SegmentedControl } from '@mantine/core';
import { MantineForm } from '../AddEditMatterForm';
import styles from './FeeTypeSegmentedControl.module.css';
import { FeeType } from '../types';
import { colorsForForm } from '../colorsForForm';

const FeeTypeSegmentedControl = ({
  feeTypes,
  mantineForm,
  onChange,
}: {
  feeTypes: FeeType[];
  mantineForm: MantineForm;
  onChange: (value: FeeType) => void;
}) => {
  const colors = colorsForForm(mantineForm);

  return (
    <SegmentedControl
      radius='20px'
      classNames={styles}
      style={
        {
          '--active-text-color': colors.foreground,
          '--active-bg-color': colors.background,
        } as React.CSSProperties
      }
      fullWidth
      data={feeTypes.map((type) => ({
        label: type,
        value: type,
      }))}
      value={mantineForm.getValues().feeType ?? ''}
      onChange={(value) => onChange(value as FeeType)}
    />
  );
};

export default FeeTypeSegmentedControl;
